<template>
  <div class="hello">
  </div>
</template>

<script>
export default {
  name: 'Main',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Main.vue